import * as yup from 'yup';

import LocalizedStrings from 'localization';

export const addUserOptionValidationSchema = yup.object().shape({
  userValue: yup.string().required(LocalizedStrings.optionRequired),
});
